// src/api/labLaunchApi.js
import api from './axios';

export const checkLabAvailability = (labId) =>
  api.get(`/labs/${labId}/availability`);

export const launchLab = (labId, durationMinutes = 60) =>
  api.post(`/labs/${labId}/launch`, { mode: 'hybrid', duration_minutes: durationMinutes });

export const extendLab = (labId, reservationId, extraMinutes = 30) =>
  api.post(`/reservations/${reservationId}/extend`, { extra_minutes: extraMinutes });

export const getAvailableLabs = (limit = 10) =>
  api.get(`/labs/available?limit=${limit}`);